import {PlayerBase} from "../../player/player.base";
import {Component, Injector, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";

@Component({
  selector: 'app-slider',
  template: `
    <div #component>
      <div style="width: 100%; height: 100%; display: grid;">
        <div #txt1 style="text-align:{{fontStyle.align}}; alignSelf:{{fontStyle.alignSelf}};">
          <div #txt2 [style.color]="color" [style.fontSize]="fontSize" [style.fontFamily]="fontFamily">
            <mat-slider #slider discrete disableRipple (change)="changeValue($event)"><input matSliderThumb value="{{value}}"/> </mat-slider>
          </div>
        </div>
      </div>
    </div>`,
  styleUrls: []
})
export class SliderComponent extends PlayerBase {
  @ViewChild('txt1', {static: true} ) txt1;
  @ViewChild('txt2', {static: true} ) txt2;
  @ViewChild('slider', {static: true} ) slider;
  fontStyle;
  value = 0;

  fontSize;
  color;
  fontFamily;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap(playerBase => {
        self = playerBase;
        const sld = this.data.Slider[0].$;
        this.slider.min = Number(sld.minimum);
        this.slider.max = Number(sld.maximum);
        this.slider.step = Number(sld.step);
        this.value = Number(sld.defaultValue);
        const font = this.data.Slider[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      switchMap( a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;

        const k = 0.04;
        const w = 20;
        const scale = k * this.fontStyle.fontSize;

        this.txt1.nativeElement.style.marginLeft = -3 * w + 3.5 * w * scale + 'px';
        this.txt1.nativeElement.style.marginRight = -3 * w + 3.5 * w * scale + 'px';

        const el1 = this.slider._elementRef.nativeElement;
        el1.style.transform = 'scale('+scale+')'
        const el2 = el1.children[2].children[1];
        el2.style.display = 'none'


        let childProviderData;
        if (this.parentPlayer!= null) {
          childProviderData = (<any>this.parentPlayer).childProviderData;
        }
        return this.invalidateData(childProviderData);
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  invalidateData(providerData: any): Observable<any> {
    this.providerData = providerData;
    if (this.providerData!=null) {
      let value = this.providerData[this.data.Slider[0].$.fieldName];
      if (value == null) {
        value = this.providerData[this.data.Slider[0].$.fieldName] = Number(this.data.Slider[0].$.defaultValue);
      }
      this.value = value;
    }
    this.changeDetectorRef.detectChanges();
    return of('a');
  }

  changeValue(event) {
    if (this.providerData!=null) {
      const fieldName = this.data.Slider[0].$.fieldName;
      this.providerData[fieldName] = Number(event.target.value);
      this.onClick(null);
    }
  }
}
